import { FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Order } from '@models';
import { OrderView } from '../OrderView';
import moment from 'moment';

type Props = {
  order: Order;
};

const OrderListItem: FC<Props> = ({ order }) => {
  return (
    <Accordion data-testid="order-list-item" TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`${order.id}-content`} id={`${order.id}-header`}>
        <Typography data-testid="order-summary">
          {order.id} - {moment(order.date_created).format('D MMM YYYY')} - {order.status}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <OrderView order={order} />
      </AccordionDetails>
    </Accordion>
  );
};

export default OrderListItem;
